"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getReadingDateTime = exports.getBackdatedDaysToToday = exports.validateDate = exports.validateInput = void 0;
var date_fns_1 = require("date-fns");
var ClientSideReadingError;
(function (ClientSideReadingError) {
    ClientSideReadingError["NonNumericChars"] = "errorsClientNonNumeric";
    ClientSideReadingError["NonNumericCharsWithoutDigits"] = "errorsClientNonNumericWithoutDigits";
    ClientSideReadingError["TooManyDigits"] = "errorsClientTooManyDigits";
    ClientSideReadingError["Decimal"] = "errorsClientDecimal";
    ClientSideReadingError["NegativeValue"] = "errorsClientNegativeValue";
    ClientSideReadingError["EmptyInput"] = "errorsClientEmpty";
})(ClientSideReadingError || (ClientSideReadingError = {}));
var validateInput = function (reading, meterDigits) {
    if (meterDigits === void 0) { meterDigits = null; }
    if (reading === null) {
        return {
            message: ClientSideReadingError.EmptyInput,
            errorName: 'reading-empty',
        };
    }
    if (isNaN(reading)) {
        return meterDigits
            ? {
                message: ClientSideReadingError.NonNumericChars,
                errorName: 'reading-non-numeric',
            }
            : {
                message: ClientSideReadingError.NonNumericCharsWithoutDigits,
                errorName: 'reading-non-numeric-without-digits',
            };
    }
    var readingAsString = "".concat(reading);
    if (readingAsString.includes('.')) {
        return {
            message: ClientSideReadingError.Decimal,
            errorName: 'reading-decimal',
        };
    }
    if (meterDigits && readingAsString.length > meterDigits) {
        return {
            message: ClientSideReadingError.TooManyDigits,
            errorName: 'reading-too-many-digits',
        };
    }
    if (reading < 1) {
        return {
            message: ClientSideReadingError.NegativeValue,
            errorName: 'reading-negative-value',
        };
    }
    return null;
};
exports.validateInput = validateInput;
var ClientSideDateError;
(function (ClientSideDateError) {
    ClientSideDateError["Invalid"] = "errorsClientDateInvalid";
    ClientSideDateError["InFuture"] = "errorsClientDateInFuture";
    ClientSideDateError["TooFarInPast"] = "errorsClientDateTooFarInPast";
    ClientSideDateError["BeforeSupplyStart"] = "errorsClientDateBeforeSupplyStart";
    ClientSideDateError["BeforeMeterExchange"] = "errorsClientDateBeforeMeterExchange";
})(ClientSideDateError || (ClientSideDateError = {}));
var validateDate = function (date, // yyyy-mm-dd format, or any date-fns can parse correctly
supplyStartDate, meterExchangeDate) {
    // is date in correct format?
    var readingDate = (0, date_fns_1.parseISO)(date);
    if (!(0, date_fns_1.isValid)(readingDate)) {
        return { message: ClientSideDateError.Invalid, errorName: 'invalid-date' };
    }
    var now = new Date();
    if ((0, date_fns_1.isAfter)(readingDate, now)) {
        return { message: ClientSideDateError.InFuture, errorName: 'future-date' };
    }
    // more than 10 days ago
    var today = (0, date_fns_1.startOfToday)();
    if ((0, date_fns_1.isBefore)(readingDate, (0, date_fns_1.subDays)(today, 9))) {
        return {
            message: ClientSideDateError.TooFarInPast,
            errorName: 'date-over-10-days-ago',
        };
    }
    // before supply start
    if ((0, date_fns_1.isBefore)(readingDate, supplyStartDate)) {
        return {
            message: ClientSideDateError.BeforeSupplyStart,
            errorName: 'date-before-ssd',
        };
    }
    // before most recent meter exchange
    if (meterExchangeDate && (0, date_fns_1.isBefore)(readingDate, meterExchangeDate)) {
        return {
            message: ClientSideDateError.BeforeMeterExchange,
            errorName: 'date-before-mex',
        };
    }
    return null;
};
exports.validateDate = validateDate;
var getBackdatedDaysToToday = function (date) {
    if (date === '' || date.toLowerCase() === 'today') {
        return 0;
    }
    var parsedDate = (0, date_fns_1.parseISO)(date);
    var day = parsedDate.getDay();
    var month = parsedDate.getMonth();
    var year = parsedDate.getFullYear();
    return Math.abs((0, date_fns_1.differenceInCalendarDays)(new Date(Number(year), Number(month) - 1, Number(day)), Date.now()));
};
exports.getBackdatedDaysToToday = getBackdatedDaysToToday;
var getReadingDateTime = function (date) {
    if (!date) {
        return '';
    }
    if (date.toLowerCase() === 'today') {
        return new Date().toISOString();
    }
    var _a = __read(date.split('/'), 3), day = _a[0], month = _a[1], year = _a[2];
    var parsed = (0, date_fns_1.parseISO)("".concat(year, "-").concat(month, "-").concat(day));
    if (!(0, date_fns_1.isValid)(parsed)) {
        return '';
    }
    return parsed.toISOString();
};
exports.getReadingDateTime = getReadingDateTime;
